import styled from '@emotion/styled';
import { rem } from '@utils';

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-flow: column;
  flex-grow: 1;
  row-gap: ${rem(16)};
  margin-bottom: ${rem(32)};
  text-align: center;

  @media (max-width: 768px) or (max-height: 844px) {
    margin-bottom: 0;
    padding: ${rem(40)} 0 ${rem(16)};
  }
}
`;

const Gfx = styled.div`
  display: inline-flex;
`;

const Title = styled.h1`
  color: inherit;
  font-size: ${rem(24)};
  font-weight: 700;
  line-height: ${rem(30)};
  margin: 0;
  max-width: var(--intro-title-max-width);
  text-transform: none;
  
  // Responsive text
  font-size: clamp(${rem(14)}, ${rem(14)} + 0.95vw, ${rem(26)});
  line-height: calc(${rem(16)} + 1.25vmax);

  @media (min-height: 844px) {
    font-size: clamp(${rem(14)}, ${rem(16)} + 0.95vw, ${rem(26)});
  }

  @media (min-width: 1024px) {
    @container main (max-width: 600px) {
      font-size: ${rem(20)};
      line-height: ${rem(24)};
    }
    
    @container main (max-width: 430px) {
      font-size: ${rem(18)};
      line-height: ${rem(22)};
    }
    
    @container main (max-width: 320px) {
      font-size: ${rem(16)};
      line-height: ${rem(20)};
    }
  } 
`;

export default {
  Header,
  Gfx,
  Title
};
